import React, { useState, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Disclosure, Transition } from '@headlessui/react';
// tslint:disable-next-line:no-submodule-imports
import ChevronRightIcon from '@heroicons/react/24/solid/ChevronRightIcon';

import messages from './messages';
interface File {
  download_link: string;
  id: string;
  extension: string;
  filename: string;
}
interface DocumentExample {
  id: string;
  file: File;
}

const DocumentExamples = ({
  open,
  documentExamples,
}: {
  open: boolean;
  documentExamples: DocumentExample[];
}) => {
  const { formatMessage } = useIntl();
  const carouselContainerRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(1);

  function handleScroll(event: React.UIEvent<HTMLDivElement>) {
    const scrollLeft = event.currentTarget.scrollLeft;
    const offsetWidth = event.currentTarget.offsetWidth;
    const activeSlide = Math.round((scrollLeft + offsetWidth) / offsetWidth);
    setActive(activeSlide);
  }

  return (
    <>
      <Disclosure.Button as={Fragment}>
        <button className="flex justify-between items-center w-full">
          <h2 className="text-lg text-green-400">
            {formatMessage(messages.howDoesABoardingPassLook)}
          </h2>
          <ChevronRightIcon
            className={`${
              open ? '-rotate-90 transform' : ''
            } h-24 w-24 text-green-400`}
          />
        </button>
      </Disclosure.Button>
      <Transition
        show={open}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <p className="whitespace-pre-line">
          {`- ${formatMessage(messages.paperBoardingPass)}
          - ${formatMessage(messages.electronicBoardingPass)}
        `}
        </p>
        <div
          onScroll={handleScroll}
          ref={carouselContainerRef}
          className="flex scroll-smooth scrollbar-hidden justify-between items-center mt-10 overflow-auto sm:overflow-hidden snap-mandatory sm:snap-none"
        >
          {documentExamples.map(documentExample => (
            <Disclosure.Panel
              static={true}
              key={documentExample?.id}
              className="min-w-full sm:min-w-0 snap-always snap-start"
            >
              <img
                src={documentExample?.file?.download_link}
                className="mx-auto"
              />
            </Disclosure.Panel>
          ))}
        </div>
        <div className="sm:hidden flex items-center justify-center">
          {documentExamples.map((documentExample, index) => (
            <span
              className={`rounded-full border-2 border-green-400 w-10 h-10 mx-5 ${
                active === index + 1 ? 'bg-primary-400' : 'bg-transparent'
              }`}
              key={documentExample?.id}
            />
          ))}
        </div>
      </Transition>
    </>
  );
};

DocumentExamples.propTypes = {
  documentExamples: PropTypes.array,
  open: PropTypes.bool,
};

export default DocumentExamples;
